import { UIMessagingState } from './types';

export const topNavigationContentMode = (state: UIMessagingState) =>
  state.topNavigationContentMode;

export const topNavigationProfile = (state: UIMessagingState) =>
  state.topNavigationProfile;

export const topNavigationLeftAction = (state: UIMessagingState) =>
  state.topNavigationLeftAction;

export const customBackActionTriggered = (state: UIMessagingState) =>
  state.customBackActionEvent;

export const customBackRoute = (state: UIMessagingState) =>
  state.customBackRoute;
